// extracted by mini-css-extract-plugin
export default {"wrapper":"Title_wrapper__aGp6l","xl":"Title_xl__tNiCj","lg":"Title_lg__uA35t","md":"Title_md__bt9rI","sm":"Title_sm__NRA5x","light":"Title_light__oeUIk","white":"Title_white__Kc4bd"};